import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function L() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const lists: any = [
        {
            title: t('secL_list1_title'),
            desc: t('secL_list1_desc'),
        },
        {
            title: t('secL_list2_title'),
            desc: t('secL_list2_desc'),
        },
        {
            title: t('secL_list3_title'),
            desc: t('secL_list3_desc'),
        },
        {
            title: t('secL_list4_title'),
            desc: t('secL_list4_desc'),
        },
    ];
    if (['za', 'es'].includes(locale)) {
        lists.pop();
    }
    if (locale === 'fr') {
        lists.push({
            title: t('secL_list5_title'),
            desc: t('secL_list5_desc'),
        });
    }
    return (
        <div id="outdoor-recreation-L" className={`outdoor-recreation-L ${css['outdoor-recreation-L']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secL_title')}</p>
                </div>
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar, Navigation]}
                    navigation={true}
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {lists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            <div className="swiper-item-text">
                                <p className="card-desc">{card?.desc}</p>
                                <p className="card-title">{card?.title}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
